export class TransitionModel {
    public ID?: number;
    public UID?: number;
    public Username?: string;
    public Status?: number;
    public OrderTransactionCode?: string;
    public OrderCodeID?: number;
    public OrderID?: number;
    public PackageType?: number;
    public Weight?: number;
    public Length?: number;
    public Width?: number;
    public Height?: number;
    public Volume?: number;
   
    public StoreDate?: string;
    public ProductName?: string;
    public CreatedDate?: string;
    public statusDetail?: any;
  }  
export class SummaryTransitionModel {
    public TotalStatusAll!: number;
    public TotalStatus12!: number;
    public TotalStatus3!: number;
    public TotalStatus4!: number;
  }
export class NonameHistoryModel {
    public ID?: number;
    public UID?: number;
    public Username?: string;
    public OrderTransactionCode?: string;
    public CreatedDate?: string;
  } 